<div class="ampel" *ngIf="result$ | async as result">
  <form [formGroup]="form">
    <div class="stages">
      <div *ngFor="let s of initiationStatuses">
        <label [class]="color(s)" [class.selected]="selected(s)">
          <input type="radio" formControlName="status" [value]="s" [attr.disabled]="loaded ? null : 'disabled'" />
          <markant-icon src="./assets/svg/m_mail.svg" class="far fa-2x mail" [class.fas]="selected(s)"></markant-icon>
          <br />
          <div class="small-button-text">
            <div>{{ s | translateBIStatus }} ({{ getCounter(s) }})</div>
          </div>
        </label>
      </div>
    </div>
    <div
      class="feedback testlistung"
      style="display: flex; justify-content: center"
      *ngIf="form.controls.status.value === BusinessInitiationStatus.testlistung"
    >
      <div class="layout">
        <label *ngFor="let s of feedbackValues">
          <input name="feedbackTestlistung" type="radio" formControlName="feedbackTestlistung" [value]="s" [attr.disabled]="loaded ? null : 'disabled'" />
          <div class="label" [class.selected]="form.controls.feedbackTestlistung.value === s">{{ s }}</div>
        </label>
      </div>
    </div>
    <div class="feedback listung" style="display: flex; justify-content: center" *ngIf="form.controls.status.value === BusinessInitiationStatus.listungGeplant">
      <div class="layout">
        <label *ngFor="let s of feedbackValues">
          <input name="feedbackListung" type="radio" formControlName="feedbackListung" [value]="s" [attr.disabled]="loaded ? null : 'disabled'" />
          <div class="label" [class.selected]="form.controls.feedbackListung.value === s">{{ s }}</div>
        </label>
      </div>
    </div>
  </form>
</div>
